import { create } from "zustand";

interface ProjectModalState {
  // Track all open modals/dialogs/menus in the Project page
  activeProjectModals: Set<string>;

  // Methods to manage Project page modal state
  addProjectModal: (modalId: string) => void;
  removeProjectModal: (modalId: string) => void;

  // Check if any Project page modal is open
  hasActiveProjectModals: () => boolean;
}

export const useProjectModalStore = create<ProjectModalState>((set, get) => ({
  activeProjectModals: new Set(),

  addProjectModal: (modalId: string) => {
    set((state) => ({
      activeProjectModals: new Set([...state.activeProjectModals, modalId]),
    }));
  },

  removeProjectModal: (modalId: string) => {
    set((state) => {
      const newModals = new Set(state.activeProjectModals);
      newModals.delete(modalId);
      return { activeProjectModals: newModals };
    });
  },

  hasActiveProjectModals: () => {
    return get().activeProjectModals.size > 0;
  },
}));
